import { useEffect, type ReactElement, type ReactNode } from "react"
import { useSelector } from "react-redux";
import { RootState } from "src/app/store";
import Navbar from "src/components/Navbar"
import DealerMain from "./Main/DealerMain"
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/app/store";
import { getEndUsersByDealerID } from "../hooks/endUsers";
import DealerAd from "./Main/DealerAd";
import { useLocation } from "react-router-dom";
import Spinner from "src/components/Spinner";
import Sidebar from "src/components/Sidebar"

export interface DealerHomeProps {
        dealerId?: string;
        browhistory: string;
}

export default function DealerHome(props: DealerHomeProps): ReactElement {
        const dispatch = useDispatch<AppDispatch>();
        const { endUsersLoading, endUsers } = useSelector((state: RootState) => state.endUsers);

        useEffect(() => {
                dispatch(getEndUsersByDealerID(props.dealerId));
        }, [])

        return <>
                <div className="grid grid-cols-[10%_90%] h-screen w-full">
                        <div>
                                <Sidebar sideBarSelected="EndUsers" />
                        </div>
                        {endUsersLoading ?
                                <Spinner title="Loading" />
                                :
                                (
                                        <div className="grid grid-rows-[10%_90%] p-2 w-full h-[inherit]">
                                                <div className="w-full">
                                                        <div></div>
                                                        <Navbar headerType="dealer" dealerId={props.dealerId} />
                                                        <div></div>
                                                </div>
                                                <div className="grid gap-2 grid-rows-1 w-full">
                                                        <DealerMain dealerID={props.dealerId} />
                                                </div>
                                        </div>
                                )
                        }
                </div>
        </>
}
